import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function ArticulosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ARTICULOS_PROPORCION = process.env.REACT_APP_URL_ARTICULOS_PROPORCION;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_SUB_LINEAS = process.env.REACT_APP_URL_SUB_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  // const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  // const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  // const URL_COMPOSICIONES = process.env.REACT_APP_URL_COMPOSICIONES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;

  const [codigo, setCodigo] = useState("");
  const [codigoProveedor, setCodigoProveedor] = useState("");
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [pesoCaja, setPesoCaja] = useState(0);
  const [pesoPieza, setPesoPieza] = useState(0);
  const [precioKilo, setPrecioKilo] = useState(0);
  const [precioTienda, setPrecioTienda] = useState(0);
  const [tamanoCaja, setTamanoCaja] = useState("NA");
  const [piezasPorCaja, setPiezasPorCaja] = useState(0);
  const [cajasPorTarima, setCajasPorTarima] = useState(0);
  const [costoUSD, setCostoUSD] = useState(0);
  const [costoMX, setCostoMX] = useState(0);
  const [venta, setVenta] = useState(0);
  const [observaciones, setObservaciones] = useState("NA");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [codigoUnidad, setCodigoUnidad] = useState("H87");
  const [lineas, setLineas] = useState([]);
  const [subLineas, setSubLineas] = useState([]);
  const [selectedSubLinea, setSelectedSubLinea] = useState("");
  const [marcas, setMarcas] = useState([]);
  // const [familias, setFamilias] = useState([]);
  // const [colecciones, setColecciones] = useState([]);
  // const [composiciones, setComposiciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [ano, setAno] = useState("2026");
  const [EAN, setEAN] = useState("NA");
  const [SKU, setSKU] = useState("NA");
  const [vendedores, setVendedores] = useState("Si");
  const [visibleInventario, setVisibleInventario] = useState("Si");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("67d0828aeb6850003cd07d66");
  const [selectedColeccion, setSelectedColeccion] = useState("67d08298eb6850003cd07d6d");
  const [selectedComposicion, setSelectedComposicion] = useState("62744b210b641700168003c1");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [articulosTodos, setArticulosTodos] = useState([]);
  const [articuloRelacionadoValue, setArticuloRelacionadoValue] = useState(null);
    const [lista1, setLista1] = useState(0);
  const [lista2, setLista2] = useState(0);
  const [lista3, setLista3] = useState(0);
  const [lista4, setLista4] = useState(0);
  const [lista5, setLista5] = useState(0);
  const [listaContenedor, setListaContenedor] = useState(0);
  const [cbm, setCbm] = useState(0);
  const [aranceles, setAranceles] = useState(0);

  const [validaBoton, setValidaBoton] = useState(true);

  const utilidad = (parseFloat(venta || 0) - parseFloat(costoMX || 0));
const porcentajeUtilidad = venta > 0
  ? (utilidad / venta) * 100
  : 0;

  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);

  const [amounts, setAmounts] = useState([]);

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_SUB_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setSubLineas(res.data))
      .catch((err) => console.log(err));
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_FAMILIAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allFamilias = res.data;
    //     setFamilias(allFamilias);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_COLECCIONES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColecciones = res.data;
    //     setColecciones(allColecciones);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_COMPOSICIONES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allComposiciones = res.data;
    //     setComposiciones(allComposiciones);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
      
      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      })
    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setArticulosTodos(res.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });
      const initialData = [];

  arrayTallas.forEach(size => {
    arrayColores.forEach(color => {
      initialData.push({
        sizeId: size.id,
        colorId: color.id,
        cantidad: "",
        ean: ""
      });
    });
  });

  setAmounts(initialData);
  }, [arrayTallas, arrayColores]);

  // Duplicar artículo: si la URL trae ?duplicar=<id>, se precargan todos los
  // datos del artículo origen para que el usuario solo cambie lo necesario.
  // El código se deja VACÍO a propósito (debe ser único) y se avisa al usuario.
  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const idOrigen = q.get("duplicar");
    if (!idOrigen) return;
    axios
      .get(`${URL_ARTICULOS}/${idOrigen}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const a = res.data;
        if (!a?._id) return;
        const num = (v) => Number(v) || 0;
        const str = (v, def = "") => (v == null || v === "" ? def : String(v));
        // El código se precarga como "<original> (Copia)" para que el alta
        // pueda guardarse tal cual; el usuario lo ajusta si quiere otro.
        const codigoCopia = `${str(a.codigo)} (Copia)`;
        setCodigo(codigoCopia);
        setSKU(codigoCopia); // U1: Codigo y SKU son lo mismo
        setCodigoProveedor(str(a.codigoProveedor));
        setNombre(str(a.nombre));
        setDescripcion(str(a.descripcion));
        setPesoCaja(num(a.pesoCaja));
        setPesoPieza(num(a.pesoPieza));
        setPrecioKilo(num(a.precioKilo));
        setPrecioTienda(num(a.precioTienda));
        setTamanoCaja(str(a.tamanoCaja, "NA"));
        setPiezasPorCaja(num(a.piezasPorCaja));
        setCajasPorTarima(num(a.cajasPorTarima));
        setCostoUSD(num(a.costoUSD));
        setCostoMX(num(a.costoMX));
        setVenta(num(a.venta));
        setObservaciones(str(a.observaciones, "NA"));
        setCodigoSAT(str(a.codigoSAT, "NA"));
        setCodigoUnidad(str(a.codigoUnidad, "H87"));
        setAno(str(a.ano, "2026"));
        setEAN(str(a.EAN, "NA"));
        setVisibleInventario(str(a.visibleInventario, "Si"));
        setLista1(num(a.lista1));
        setLista2(num(a.lista2));
        setLista3(num(a.lista3));
        setLista4(num(a.lista4));
        setLista5(num(a.lista5));
        setListaContenedor(num(a.listaContenedor));
        setCbm(num(a.cbm));
        setAranceles(num(a.aranceles));
        // Relaciones (vienen populadas o como id)
        const refId = (v) => {
          const x = Array.isArray(v) ? v[0] : v;
          if (!x) return "";
          return typeof x === "string" ? x : x._id || "";
        };
        setSelectedLinea(refId(a.lineas));
        setSelectedSubLinea(refId(a.subLineas));
        setSelectedMarca(refId(a.marcas));
        setSelectedProveedor(refId(a.proveedores));
        setSelectedEmpresa(refId(a.empresas));
        Swal.fire({
          icon: "info",
          title: "Artículo duplicado",
          html: `Se copiaron los datos de <b>${str(a.codigo)} ${str(a.nombre)}</b>.<br/>El código quedó como <b>${codigoCopia}</b>; cámbialo si necesitas otro y ajusta lo demás.`,
        });
      })
      .catch((err) => {
        console.log("[duplicar articulo]", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cargar el artículo a duplicar",
        });
      });
  }, []);

  function coloresSeleccionados(checked, color) {
    if (checked) {
      setArrayColores([...arrayColores, {id: color._id, name: color.name}]);
    } else {
      const values = [...arrayColores];
      const indexToRemove = values.findIndex(t => t.id === color._id);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayColores(values);
      }
    }
  }

  function tallasSeleccionados(checked, talla) {
    if (checked) {
      setArrayTallas([...arrayTallas, {id: talla._id, name: talla.name}]);
    } else {
      const values = [...arrayTallas];
      const indexToRemove = values.findIndex(t => t.id === talla._id);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayTallas(values);
      }
    }
  }
  

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);

    const arrayTallasOfIds = arrayTallas.map(talla => talla.id)
    const arrayColoresOfIds = arrayColores.map(c => c.id)

let totalProporcion = amounts.length
    try {
      await axios
        .post(
          URL_ARTICULOS,
          {
            codigo,
            nombre,
            descripcion: nombre,
            pesoCaja,
            pesoPieza,
            precioKilo,
            tamanoCaja,
            piezasPorCaja,
            cajasPorTarima: Number(cajasPorTarima) || 0,
            costoUSD,
            costoMX,
            venta,
            observaciones,
            codigoSAT,
            codigoUnidad,
            lineas: selectedLinea,
            subLineas: selectedSubLinea || undefined,
            marcas: selectedMarca,
            familias: selectedFamilia,
            colecciones: selectedColeccion,
            composiciones: selectedComposicion,
            proveedores: selectedProveedor,
            ano,
            EAN,
            SKU,
            vendedores,
            visibleInventario,
            colores: arrayColoresOfIds,
            tallas: arrayTallasOfIds,
            precioTienda,
            empresas: selectedEmpresa,
            lista1,
            lista2,
            lista3,
            lista4,
            lista5,
            listaContenedor,
            cbm,
            aranceles,
            articuloRelacionado: articuloRelacionadoValue
              ? [articuloRelacionadoValue._id]
              : [],
            codigoProveedor: codigoProveedor && codigoProveedor.trim() !== ""
              ? codigoProveedor.trim()
              : codigo,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          axios
            .post(
              URL_INVENTARIOS,
              {
                articulos: data.data._id,
                areas: AREAS_CEDIS,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              if(amounts.length > 0){
              amounts.map((a)=>{
                axios.post(
                  URL_ARTICULOS_PROPORCION,
                  {
                    articulos: data.data._id,
                    cantidad: a.cantidad,
                    EAN: a.ean,
                    colores: a.colorId,
                    tallas: a.sizeId
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                ).then(()=>{
                  totalProporcion = totalProporcion - 1
                  if(totalProporcion == 0){
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Crear Modelo",
                        detalle: `${nombre} ${codigo}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                  
                }).catch((error)=>{
                  console.log(error)
                  setValidaBoton(true)
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                })
              })   
            }else{
              axios.post(
                URL_LOGS,
                {
                  tipo: "Crear modelos",
                  detalle: `${nombre} ${codigo}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
             
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };


  const handleInputChange = (sizeId, colorId, value, field) => {
    const updated = amounts.map(entry => {
      if (entry.sizeId === sizeId && entry.colorId === colorId) {
        return {
          ...entry,
          [field]:
            field === 'cantidad'
              ? value === '' ? '' : parseInt(value)
              : value
        };
      }
      return entry;
    });
  
    setAmounts(updated);
  };


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container">
          <h3 align="center">Nuevo Producto</h3>
          {/* <Get/> */}
          <Form onSubmit={saveArticulos}>
            <Row>
              <Col md={3}>
                <Label>Codigo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                    setSKU(e.target.value); // Codigo y SKU son lo mismo
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Codigo Proveedor</Label>
                <Input
                  type="text"
                  placeholder="(opcional, usa codigo si esta vacio)"
                  value={codigoProveedor}
                  onChange={(e) => {
                    setCodigoProveedor(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Piezas Por Caja</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Piezas Por Caja"
                  value={piezasPorCaja}
                  required
                  onChange={(e) => {
                    setPiezasPorCaja(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Label>EAN</Label>
                <Input
                  type="text"
                  placeholder="EAN"
                  value={EAN}
                  required
                  onChange={(e) => {
                    setEAN(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>FOB USD</Label>
                <Input
                  type="text"
                  placeholder="FOB USD"
                  value={costoUSD}
                  required
                  onChange={(e) => {
                    setCostoUSD(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Costo MX</Label>
                <Input
                  type="text"
                  placeholder="Costo MX"
                  value={costoMX}
                  required
                  onChange={(e) => {
                    setCostoMX(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Aranceles</Label>
                <Input
                  type="text"
                  placeholder="Aranceles"
                  value={aranceles}
                  required
                  onChange={(e) => {
                    setAranceles(e.target.value);
                  }}
                />
              </Col>
              {/* <Col md={3}>
                <Label>Venta</Label>
                <Input
                  type="text"
                  placeholder="Venta"
                  value={venta}
                  required
                  onChange={(e) => {
                    setVenta(e.target.value);
                  }}
                />
              </Col> */}
              </Row>
              <Row>
              {/* <Col md={3}>
  <Label>Utilidad</Label>
  <Input
    type="text"
    value={`$ ${utilidad.toFixed(2)}`}
    disabled
  />
</Col>

<Col md={3}>
  <Label>% Utilidad</Label>
  <Input
    type="text"
    value={`${porcentajeUtilidad.toFixed(2)} %`}
    disabled
  />
</Col> */}
{/* <Col md={3}>
                <Label>Precio A Tienda</Label>
                <Input
                  type="number"
                  value={precioTienda}
                  required
                  onChange={(e) => {
                    setPrecioTienda(e.target.value);
                  }}
                />
              </Col> */}
            </Row>
            <Row>

            

             
              <Col md={3}>
                <Label className="mr-sm-2">Categoria</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedLinea}
                  required
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                    setSelectedSubLinea("");
                  }}
                >
                  <option value="0">Selecciona una Categoria</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">SubCategoria</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedSubLinea}
                  onChange={(e) => setSelectedSubLinea(e.target.value)}
                >
                  <option value="">Selecciona una SubCategoria</option>
                  {subLineas
                    .filter((s) => !selectedLinea || (s.lineas?.[0]?._id || s.lineas?.[0]) === selectedLinea)
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>{a.name}</option>
                    ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Marca</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedMarca}
                  required
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Marca</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              {/* <Col md={3}>
                <Label className="mr-sm-2">Familia</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedFamilia}
                  required
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Familia</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> 
            </Row>
            <Row>
               <Col md={3}>
                <Label className="mr-sm-2">Coleccion</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedColeccion}
                  required
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Coleccion</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> */}
              {/* <Col md={3}>
                <Label>Año</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={ano}
                  required
                  onChange={(e) => {
                    setAno(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Año</option>
                  {years.map((a) => {
                    return <option value={a}>{a}</option>;
                  })}
                </Input>
              </Col> */}
{/* SKU sincronizado con Codigo (U1) */}

              {/* <Col md={3}>
                <Label className="mr-sm-2">Composicion</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedComposicion}
                  required
                  onChange={(e) => {
                    setSelectedComposicion(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Composicion</option>
                  {composiciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> */}
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Tamaño Caja</Label>
                <Input
                  type="text"
                  placeholder="Tamaño Caja"
                  value={tamanoCaja}
                  required
                  onChange={(e) => {
                    setTamanoCaja(e.target.value);
                  }}
                />
              </Col>

            <Col md={3}>
                <Label>Peso Caja (kg)</Label>
                <Input
                  type="number"
                  step="any"
                  placeholder="Peso Caja"
                  value={pesoCaja}
                  required
                  onChange={(e) => {
                    setPesoCaja(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Peso Pieza (kg)</Label>
                <Input
                  type="number"
                  step="any"
                  placeholder="Peso por pieza en kg"
                  value={pesoPieza}
                  onChange={(e) => setPesoPieza(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label>Precio por Kilo (USD)</Label>
                <Input
                  type="number"
                  step="any"
                  placeholder="USD por kg negociado"
                  value={precioKilo}
                  onChange={(e) => setPrecioKilo(e.target.value)}
                />
                {parseFloat(precioKilo) > 0 && parseFloat(pesoPieza) > 0 && (
                  (() => {
                    const fobEsperado = parseFloat(precioKilo) * parseFloat(pesoPieza);
                    const fobReal = parseFloat(costoUSD) || 0;
                    const diff = fobReal - fobEsperado;
                    const pctDiff = fobEsperado > 0 ? (diff / fobEsperado) * 100 : 0;
                    const color = Math.abs(pctDiff) < 1 ? "#28a745" : diff > 0 ? "#dc3545" : "#17a2b8";
                    return (
                      <small style={{ color, fontWeight: "bold" }}>
                        FOB esperado: ${fobEsperado.toFixed(4)} | Real: ${fobReal.toFixed(4)}
                        {fobReal > 0 && (
                          <> | Dif: {diff >= 0 ? "+" : ""}${diff.toFixed(4)} ({pctDiff.toFixed(1)}%)</>
                        )}
                      </small>
                    );
                  })()
                )}
              </Col>
               <Col md={3}>
                <Label>CBM (m³)</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={cbm}
                  onChange={(e) => setCbm(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label>Visible Vendedores</Label>
                <Input
                  type="select"
                  value={vendedores}
                  required
                  onChange={(e) => {
                    setVendedores(e.target.value);
                  }}
                >
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col>
              <Col md={3}>
              <Label>Empresa</Label>
                <Input
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Empresa</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Cajas Por Tarima</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Cajas Por Tarima"
                  value={cajasPorTarima}
                  onChange={(e) => {
                    setCajasPorTarima(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Codigo SAT</Label>
                <Input
                  type="text"
                  placeholder="CodigoSAT"
                  value={codigoSAT}
                  required
                  onChange={(e) => {
                    setCodigoSAT(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Codigo Unidad</Label>
                <Input
                  type="text"
                  placeholder="CodigoUnidad"
                  value={codigoUnidad}
                  required
                  onChange={(e) => {
                    setCodigoUnidad(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Visible Inventario</Label>
                <Input
                  type="select"
                  value={visibleInventario}
                  required
                  onChange={(e) => {
                    setVisibleInventario(e.target.value);
                  }}
                >
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label>Articulo Relacionado</Label>
                <Autocomplete
                  size="small"
                  value={articuloRelacionadoValue}
                  onChange={(event, sel) => {
                    setArticuloRelacionadoValue(sel || null);
                  }}
                  options={(articulosTodos || []).slice().sort((a, b) =>
                    (a.codigo || "").localeCompare(b.codigo || "")
                  )}
                  getOptionLabel={(option) =>
                    option && (option.codigo || option.nombre)
                      ? `${option.codigo || ""} ${option.nombre || ""}`
                      : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.codigo} {option.nombre}
                    </React.Fragment>
                  )}
                />
              </Col>
            </Row>
            <br />
            <h4>Precios de Venta</h4>
            <small style={{ color: "#666" }}>
              Lista 1 es base. Lista 2 = Lista 1 − 30% (se sincronizan automáticamente).
            </small>
            <Row>
            <Col md={2}>
                <Label>Lista 1 (base)</Label>
                <Input
                     type="number"
                     min="0"
                     step="any"
                  value={lista1}
                  required
                  onChange={(e) => {
                    const v = e.target.value;
                    setLista1(v);
                    const n = parseFloat(v);
                    if (!isNaN(n)) {
                      setLista2(Number((n * 0.7).toFixed(2)));
                      setLista3(Number((n * 0.75).toFixed(2)));
                      setLista4(Number((n * 0.8).toFixed(2)));
                      setLista5(Number((n * 0.85).toFixed(2)));
                    } else {
                      setLista2(0); setLista3(0); setLista4(0); setLista5(0);
                    }
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Lista 2 (−30%)</Label>
                <Input
                     type="number"
                     min="0"
                     step="any"
                  value={lista2}
                  required
                  onChange={(e) => {
                    const v = e.target.value;
                    setLista2(v);
                    const n = parseFloat(v);
                    if (!isNaN(n) && n > 0) {
                      const base = n / 0.7;
                      setLista1(Number(base.toFixed(2)));
                      setLista3(Number((base * 0.75).toFixed(2)));
                      setLista4(Number((base * 0.8).toFixed(2)));
                      setLista5(Number((base * 0.85).toFixed(2)));
                    }
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Lista 3 (−25%)</Label>
                <Input
                    type="number"
                    min="0"
                    step="any"
                  value={lista3}
                  required
                  onChange={(e) => {
                    const v = e.target.value;
                    setLista3(v);
                    const n = parseFloat(v);
                    if (!isNaN(n) && n > 0) {
                      const base = n / 0.75;
                      setLista1(Number(base.toFixed(2)));
                      setLista2(Number((base * 0.7).toFixed(2)));
                      setLista4(Number((base * 0.8).toFixed(2)));
                      setLista5(Number((base * 0.85).toFixed(2)));
                    }
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Lista 4 (−20%)</Label>
                <Input
                     type="number"
                     min="0"
                     step="any"
                  value={lista4}
                  required
                  onChange={(e) => {
                    const v = e.target.value;
                    setLista4(v);
                    const n = parseFloat(v);
                    if (!isNaN(n) && n > 0) {
                      const base = n / 0.8;
                      setLista1(Number(base.toFixed(2)));
                      setLista2(Number((base * 0.7).toFixed(2)));
                      setLista3(Number((base * 0.75).toFixed(2)));
                      setLista5(Number((base * 0.85).toFixed(2)));
                    }
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Lista 5 (−15%)</Label>
                <Input
                     type="number"
                     min="0"
                     step="any"
                  value={lista5}
                  onChange={(e) => {
                    const v = e.target.value;
                    setLista5(v);
                    const n = parseFloat(v);
                    if (!isNaN(n) && n > 0) {
                      const base = n / 0.85;
                      setLista1(Number(base.toFixed(2)));
                      setLista2(Number((base * 0.7).toFixed(2)));
                      setLista3(Number((base * 0.75).toFixed(2)));
                      setLista4(Number((base * 0.8).toFixed(2)));
                    }
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Lista Contenedor</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={listaContenedor}
                  onChange={(e) => setListaContenedor(e.target.value)}
                />
              </Col>
             
            </Row>
            {/* <Row>
            <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Colores
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Colores"
                      onClick={(e) => toggleColores()}
                    >
                      <i class="fas fa-palette fa-2x "></i>
                    </Button>
                  </Col>

                  <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Tallas
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Tallas"
                      onClick={(e) => toggleTallas()}
                    >
                      <i class="fas fa-ruler-horizontal fa-2x "></i>
                    </Button>
                  </Col>
            </Row>
            <br />

            <Row>
            <div className="card container">
            <h4>Proporción</h4>
<Table>
  <thead>
    <tr>
      <th></th>
      {arrayColores.map(color => (
        <th key={color.id}>{color.name}</th>
      ))}
    </tr>
  </thead>
  <tbody>
    {arrayTallas.map(size => (
      <tr key={size.id}>
        <td>{size.name}</td>
        {arrayColores.map(color => {
          const cell = amounts.find(entry => entry.sizeId === size.id && entry.colorId === color.id) || { cantidad: 0, ean: '' };

          return (
            <td key={color.id}>
              <input
                type="number"
                value={cell.cantidad === 0 ? "" : cell.cantidad}
                onChange={(e) =>
                  handleInputChange(
                    size.id,
                    color.id,
                    e.target.value,
                    "cantidad"
                  )
                }
                min="0"
              />
            </td>
          );
        })}
      </tr>
    ))}
  </tbody>
</Table>

          </div>
            </Row>

            <Row>
            <div className="card container">
            <h4>EAN</h4>
<Table>
  <thead>
    <tr>
      <th></th>
      {arrayColores.map(color => (
        <th key={color.id}>{color.name}</th>
      ))}
    </tr>
  </thead>
  <tbody>
    {arrayTallas.map(size => (
      <tr key={size.id}>
        <td>{size.name}</td>
        {arrayColores.map(color => {
          const cell = amounts.find(entry => entry.sizeId === size.id && entry.colorId === color.id) || { cantidad: 0, ean: '' };

          return (
            <td key={color.id}>
              <input
                type="text"
                value={cell.ean || ''}
                onChange={(e) => handleInputChange(size.id, color.id, e.target.value, 'ean')}
              />
            </td>
          );
        })}
      </tr>
    ))}
  </tbody>
</Table>

          </div>
            </Row> */}
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoArticulos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />

          <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
            <ModalHeader toggle={toggleColores}>
              <h4>Colores del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {colores
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a, index) => {
                    return (
                      <table>
                        <td>
                          <Input
                            type="checkbox"
                            key={index}
                            onChange={(e) => {
                              coloresSeleccionados(
                                e.currentTarget.checked,
                                a
                              );
                            }}
                            className="subMenu"
                          />
                          <h5 className="subMenuTitulo">{a.name}</h5>
                        </td>
                      </table>
                    );
                })}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
            <ModalHeader toggle={toggleTallas}>
              <h4>Tallas del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {tallas
                // .sort((a, b) => (a.idTalla > b.idTalla ? 1 : -1))
                .map((a, index) => {
                    return (
                      <table>
                        <td>
                          <Input
                            type="checkbox"
                            key={index}
                            onChange={(e) => {
                              tallasSeleccionados(
                                e.currentTarget.checked,
                                a
                              );
                            }}
                            className="subMenu"
                          />
                          <h5 className="subMenuTitulo">{a.name}</h5>
                        </td>
                      </table>
                    );
                })}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosCreate;
